export default [{
  flag: 'us',
  language: 'en',
  title: 'English',
},
{
  flag: 'ar',
  language: 'ar',
  title: 'الإنجليزية',
},
]



// WEBPACK FOOTER //
// ./src/helper/Languages.js